export default __webpack_public_path__ + "static/media/logo-light.469cc31b.svg";